module.exports = __webpack_public_path__ + "img/c-thermometer-img6-2.2de067cb.png";